import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TablePagination,
  CircularProgress,
  Button,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

const CostMasterTable = ({ costMasterList, loading, handleEditData, onDelete }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll for better UX
    });
  };

  return (
    <Paper>
      <TableContainer>
        <Table>
          {/* Table Header */}
          <TableHead>
            <TableRow style={{ backgroundColor: "#4cb5f5" }}>
              <TableCell style={{ color: "#fff" }}>S.No</TableCell>
              <TableCell style={{ color: "#fff" }}>Code</TableCell>
              <TableCell style={{ color: "#fff" }}>Name</TableCell>
              <TableCell style={{ color: "#fff" }}>Description</TableCell>
              <TableCell style={{ color: "#fff" }}>Department</TableCell>
              <TableCell style={{ color: "#fff" }}>Owner</TableCell>
              <TableCell style={{ color: "#fff" }}>Type</TableCell>
              <TableCell style={{ color: "#fff" }}>Location</TableCell>
              <TableCell style={{ color: "#fff" }}>Create Date</TableCell>
              <TableCell style={{ color: "#fff" }}>Validity</TableCell>
              <TableCell style={{ color: "#fff" }}>Status</TableCell>
              <TableCell style={{ color: "#fff" }}>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : costMasterList.length > 0 ? (
              costMasterList
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#f5f5f5",
                    }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{item.code}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell>{item.department}</TableCell>
                    <TableCell>{item.owner}</TableCell>
                    <TableCell>{item.type}</TableCell>
                    <TableCell>{item.location}</TableCell>
                    <TableCell>{item.create_date}</TableCell>
                    <TableCell>{item.validity}</TableCell>
                    <TableCell>{item.status ? "Active" : "Inactive"}</TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => {
                            scrollToTop(); // Scroll to top
                            handleEditData(item);
                          }}
                      >
                        <Edit fontSize="small" />
                      </Button>
                      <Button
                        size="small"
                        color="secondary"
                        onClick={() => onDelete(item.id)}
                      >
                        <Delete fontSize="small" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center" style={{ color: "red" }}>
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={costMasterList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default CostMasterTable;
